var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 556,
    width: 28,
    height: 29
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)",
    transform: "translate(-162 -556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.125 6.125 6.125 21.875 21.875 21.875 21.875 6.125ZM20.125 20.125 7.875 20.125 7.875 7.875 20.125 7.875Z",
    fill: "current",
    transform: "matrix(1 0 0 1.03571 162 556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1462 10.9661 17.9212 9.71629 12.4282 15.099 10.092 12.7627 8.85442 14 12.4157 17.5612 19.1462 10.9661Z",
    fill: "current",
    transform: "matrix(1 0 0 1.03571 162 556)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCheck);
export default __webpack_public_path__ + "static/media/nav-check.b81133bee33c6748c0fd20e47f433c39.svg";
export { ForwardRef as ReactComponent };